var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",style:('margin:' +
    _vm.margin +
    'px auto;width:' +
    _vm.width +
    'px;height:' +
    _vm.height +
    'px;')},[_c('div',{staticClass:"rect1",style:('width:' + _vm.width / 10 + 'px')}),_c('div',{staticClass:"rect2",style:('width:' + _vm.width / 10 + 'px')}),_c('div',{staticClass:"rect3",style:('width:' + _vm.width / 10 + 'px')}),_c('div',{staticClass:"rect4",style:('width:' + _vm.width / 10 + 'px')}),_c('div',{staticClass:"rect5",style:('width:' + _vm.width / 10 + 'px')}),(_vm.text != '')?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }